export default __webpack_public_path__ + "static/media/Yash-Patni.e6bb45bc.pdf";